import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
    formatEditionTitle,
} from '@news-mono/web-common'
import { SpecialEditionHome } from './SpecialEditionHome'
import { EditionPublication } from '@west-australian-newspapers/message-types'
import { NightlyLatestEdition } from '../LatestEdition/NightlyLatestEdition'

export interface SpecialEditionHomeRouteProps {
    publicationTitle: string
    lazyloadImages?: boolean
    publication: EditionPublication
    isTopSection?: boolean
    heading?: string
    showFirstDivider?: boolean
}

export const NightlySpecialEditionHomeRegistration =
    createRegisterableComponentWithData(
        'nightly-special-edition-home',
        EditionLoader,
        (
            {
                publicationTitle,
                lazyloadImages,
                publication,
                isTopSection = false,
                heading,
                showFirstDivider,
            }: SpecialEditionHomeRouteProps,
            data,
            services,
        ) => {
            if (!data.loaded) return null
            const edition = data.result.documents?.[0]
            if (!edition) {
                services?.log?.error(data, 'SpecialEditionHome: empty result')
                return null
            }

            const normalizedEditionTitle =
                heading || formatEditionTitle(edition.title) || 'Latest Edition'

            if (isTopSection) {
                return (
                    <NightlyLatestEdition
                        edition={edition}
                        title={normalizedEditionTitle}
                        lazyloadImages={lazyloadImages}
                        onEvent={services.onEvent}
                        type={'homepage'}
                    />
                )
            }

            return (
                <SpecialEditionHome
                    edition={edition}
                    publicationTitle={publicationTitle}
                    lazyloadImages={lazyloadImages}
                    onEvent={services.onEvent}
                    publication={publication}
                    heading={heading}
                    showFirstDivider={showFirstDivider}
                />
            )
        },
    )
